import React from "react";
import { Link } from "react-router-dom";

import {
    Card,
    CardActionArea,
    CardContent,
    Typography,
    CardHeader,
    Tooltip,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import RenderDate from "../../Common/Date/RenderDate";

import RSAvatar from "./RSAvatar";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const exceptions = [
    {
        id: 1,
        title: "ESR - 1",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "published",
    },
    {
        id: 2,
        title: "ESR - 2",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "draft",
    },
    {
        id: 3,
        title: "ESR - 3",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "published",
    },
    {
        id: 4,
        title: "ESR - 4",
        days: 1,
        dateStart: "2021-01-01T11:03:47.166Z",
        dateEnd: "2022-12-31T11:03:47.166Z",
        status: "published",
    },
];

function RSCard() {
    return (
        <Card className="card">
            <CardActionArea
                component={Link}
                to={`/rs/rosters/`}
                centerRipple={true}
            >
                <CardHeader
                    disableTypography={true}
                    avatar={
                        <Tooltip title="view all rosters" arrow>
                            <RSAvatar type="roster" />
                        </Tooltip>
                    }
                    title={
                        <Typography
                            component="h3"
                            className="card-header-title"
                        >
                            Rostering
                        </Typography>
                    }
                    subheader={
                        <Typography
                            component="h4"
                            className="card-header-subtitle"
                        >
                            4 rosters available
                        </Typography>
                    }
                />
            </CardActionArea>
            <CardContent>
                <TableContainer>
                    <Table aria-label="customized table">
                        <TableBody>
                            {exceptions.map((row, index) => (
                                <StyledTableRow key={index}>
                                    <StyledTableCell component="th" scope="row">
                                        <Link
                                            to={`/rs/rosters/${
                                                Number(row.id) || ""
                                            }`}
                                        >
                                            {row.title}
                                        </Link>
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                        <RenderDate date={row.dateStart} />
                                        &nbsp;-&nbsp;
                                        <RenderDate date={row.dateEnd} />
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))}

                            <StyledTableRow key="totals">
                                <StyledTableCell
                                    component="th"
                                    scope="row"
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                ></StyledTableCell>
                                <StyledTableCell
                                    align="right"
                                    sx={{ backgroundColor: "#FFFFFF" }}
                                ></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
}

export default RSCard;
